export default __webpack_public_path__ + "static/DSC_0149-5a715311449d83d7c4bd837e6a72d37d.jpg";